// Единый справочник статусов (classification) простоев для страницы статистики.
// Цвета тегов — по аналогии со страницей простоев (pages/downtimes/downtimeOptions.mjs).

export const DOWNTIME_STATUSES = [
  {
    value: 'confirmed',
    label: 'Подтверждённый простой',
    shortLabel: 'Прост.',
    color: '#b42318',
    background: '#fee4e2',
    chartColor: '#f04438',
  },
  {
    value: 'potential',
    label: 'Потенциальный простой',
    shortLabel: 'Потен.',
    color: '#7a5d00',
    background: '#fef0c7',
    chartColor: '#f79009',
  },
  {
    value: 'late',
    label: 'Опоздание',
    shortLabel: 'Опозд.',
    color: '#b54708',
    background: '#ffead5',
    chartColor: '#3b82f6',
  },
  {
    value: 'resolved',
    label: 'Урегулирован',
    shortLabel: 'Урег.',
    color: '#027a48',
    background: '#ecfdf3',
    chartColor: '#12b76a',
  },
  {
    value: 'incomplete',
    label: 'Нет фактических данных',
    shortLabel: 'Нет ФД',
    color: '#175cd3',
    background: '#eff8ff',
    chartColor: '#98a2b3',
  },
  {
    value: 'none',
    label: 'Без классификации',
    shortLabel: '—',
    color: '#667085',
    background: '#ffffff',
    chartColor: '#d0d5dd',
  },
  {
    value: 'no_plan',
    label: 'Нет плановой даты',
    shortLabel: 'Нет плана',
    color: '#475467',
    background: '#f2f4f7',
    chartColor: '#667085',
  },
];

export const DOWNTIME_STATUS_VALUES = DOWNTIME_STATUSES.map((item) => item.value);

const FALLBACK_STATUS = DOWNTIME_STATUSES.find((item) => item.value === 'none');

export function downtimeStatusMeta(value) {
  return (
    DOWNTIME_STATUSES.find((item) => item.value === value) || FALLBACK_STATUS
  );
}

export const DOWNTIME_LIFECYCLE_OPTIONS = [
  { value: 'open', label: 'Открыт' },
  { value: 'registered', label: 'Зарегистрирован' },
  { value: 'resolved', label: 'Урегулирован' },
  { value: 'stale', label: 'Устарел' },
];

const FALLBACK_LIFECYCLE = { value: null, label: '—' };

export function downtimeLifecycleLabel(value) {
  const match = DOWNTIME_LIFECYCLE_OPTIONS.find((item) => item.value === value);
  return match ? match.label : FALLBACK_LIFECYCLE.label;
}
